export const QUERY_KEYS = {
  IMPRESSIONS_DISTRIBUTION: 'impressions-distribution',
  TOP_CHARTS: 'topChars',
} as const;
